import { CloseIcon, PDFIcon, XML } from "assets/Imports";
import "./InvoiceAdminCard.scss";
import "./InvoiceAdminCardDetalle.scss";
import { useEffect, useRef, useState } from "react";
import { RejectInvoiceModal } from "./RejectInvoiceModal";
import "./RequestInvoiceModal.scss";
import { InvoiceData, firebaseDateFormatter } from "@services/InvoiceServices";
import { UserProfileModal } from "../PaymentRequestContainer/components/UserProfileModal/UserProfileModal";
import { getGenerationNameById } from "@services/GenerationService";
import { doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "initFirebase";
import { useLocation } from "react-router-dom";
import { SpinnerCustom } from "@components/Spinner/SpinnerMyAccountView";
import useCollaboratorLogs, { collaborator, user } from "@hooks/collaborators/useCollaboratorLogs";
import { Timestamp } from "firebase/firestore";
import { Alert } from "react-bootstrap";
import { Bottletrash } from "assets/Imports";
import Swal from "sweetalert2";
import toast from "react-hot-toast";
import { InvoiceActionsModal } from "./components/InvoiceActionsModal/InvoiceActionsModal";
import { FISCAL_REGIMES } from "./fiscalRegimes";
import { MontoBar } from "./components/InvoiceTaxes/MontoBar";
import { USOS_CFDI } from "./usoCfdi";
import {
	AmountMode,
	InvoiceTaxConfig,
	breakdownText,
	computeBreakdownFor,
	defaultTaxConfig,
	isPersonaMoral,
	money,
	validateTaxConfig,
} from "@services/invoiceTaxes";

export function InvoiceAdmincard({ invoice, ...props }) {
	const isPending = invoice.status === "Pending";
	const statusColor =
		invoice.status === "Rejected" || invoice.status === "Canceled" ? "red" : isPending ? "grey" : "green";
	const [view, setView] = useState<number>(1);
	const [userProfileModal, setUserProfileModal] = useState<boolean>(false);
	const [invoiceActionsModal, setInvoiceActionsModal] = useState<boolean>(false);
	const [reqDate, setReqDate] = useState<string>();
	const [rejectedDate, setRejectedDate] = useState<string>();
	const [acceptedDate, setAcceptedDate] = useState<string>();
	const [canceledDate, setCanceledDate] = useState<string>();
	const [userGenName, setUserGenName] = useState<string>();
	const [ableToCancel, setAbleToCancel] = useState<boolean>();
	const [modified, setModified] = useState<boolean>(false); // State to check whether changes have been made in the invoice (For "solicitudes" categorie)
	const [loader, setLoader] = useState<boolean>(false);
	// Impuestos de la solicitud (solo personal): se editan aquí junto con los demás datos
	// y se usan al pulsar "Aprobar". Por defecto según el RFC (12 = persona moral).
	const [rfcDraft, setRfcDraft] = useState<string>(invoice.rfc ?? "");
	const [amountDraft, setAmountDraft] = useState<string>(String(invoice.amount ?? ""));
	const [amountMode, setAmountMode] = useState<AmountMode>("total");
	// Si al crear la solicitud se eligieron impuestos, se usan esos; si no, los de su RFC.
	const [taxCfg, setTaxCfg] = useState<InvoiceTaxConfig>(invoice.taxConfig ?? defaultTaxConfig(invoice.rfc));
	const draftIsMoral = isPersonaMoral(rfcDraft);
	const firstRfcCheck = useRef(true);
	useEffect(() => {
		if (firstRfcCheck.current) {
			firstRfcCheck.current = false;
			return;
		}
		setTaxCfg(defaultTaxConfig(rfcDraft));
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, [draftIsMoral]);
	const draftBreakdown = !validateTaxConfig(taxCfg)
		? computeBreakdownFor(amountMode, parseFloat(amountDraft), taxCfg)
		: null;
	const trackDraft = (e: any) => {
		if (e.target?.name === "rfc") setRfcDraft(e.target.value);
		if (e.target?.name === "invoiceAmount") setAmountDraft(e.target.value);
	};
	const { invoiceLog } = useCollaboratorLogs();
	const [selectedFiscalRegime, setSelectedFiscalRegime] = useState(invoice.fiscalRegime);
	const [selectedUse, setSelectedUse] = useState(invoice.use);
	const [selectedPaymentForm, setSelectedPaymentForm] = useState(invoice.paymentForm);

	let defaultDateValue = ""; // o puedes usar una fecha por defecto

	if (invoice.requestDate) {
		const date = invoice.requestDate.toDate(); // Convertir de Timestamp a Date
		date.setHours(12); // Ajustar la hora a mediodía
		defaultDateValue = date.toISOString().split("T")[0];
	}

	const location: any = useLocation();
	const cardRef: any = useRef(null);

	const statusSpanish = {
		Pending: "Pendiente",
		Accepted: "Aprobada",
		Rejected: "Negado",
		AutoGenerated: "Autogenerada",
		AdminGenerated: "Aprobada",
		Canceled: "Cancelada",
	};
	const paymentFormText = {
		"01": "Efectivo",
		"02": "Cheque nominativo",
		"03": "Transferencia electrónica de fondos",
		"04": "Tarjeta de crédito",
		"05": "Monedero electrónico",
		"06": "Dinero electrónico",
		"08": "Vales de despensa",
		"12": "Dación en pago",
		"13": "Pago por subrogación",
		"14": "Pago por consignación",
		"15": "Condonación",
		"17": "Compensación",
		"23": "Novación",
		"24": "Confusión",
		"25": "Remisión de deuda",
		"26": "Prescripción o caducidad",
		"27": "A satisfacción del acreedor",
		"28": "Tarjeta de débito",
		"29": "Tarjeta de servicios",
		"30": "Aplicación de anticipos",
		"31": "Intermediario pagos",
		"99": "Por definir",
	};

	const handleViewChange1 = () => setView(1);
	const handleViewChange2 = () => setView(2);
	const handleViewChange3 = () => setView(3);

	const handleSaveChanges = async (e) => {
		e.preventDefault();
		const form = e.target.form;
		const docRef = doc(db, "invoices", invoice.id);

		let selectedDate = new Date(form.requestDate.value);
		selectedDate.setHours(selectedDate.getHours() + selectedDate.getTimezoneOffset() / 60);
		const firebaseDate = Timestamp.fromDate(selectedDate);
		// Se guarda siempre lo que pagará el cliente (total) y su subtotal según los impuestos de la tarjeta.
		const typed = parseFloat(form.invoiceAmount.value);
		const savedBreakdown = !validateTaxConfig(taxCfg) ? computeBreakdownFor(amountMode, typed, taxCfg) : null;
		const savedAmount = savedBreakdown ? savedBreakdown.total : typed;
		const savedNetPrice = savedBreakdown ? savedBreakdown.subtotal : parseFloat((typed / 1.16).toFixed(2));

		updateDoc(docRef, {
			rfc: form.rfc.value,
			corporateName: form.corporateName.value.toUpperCase(),
			email: form.email.value,
			zipCode: form.zipCode.value,
			amount: savedAmount,
			netPrice: savedNetPrice,
			fiscalRegime: selectedFiscalRegime,
			street: form.street.value,
			city: form.city.value,
			use: selectedUse,
			state: form.state.value,
			paymentForm: selectedPaymentForm.replace(/_\d+$/, ""),
			requestDate: firebaseDate,
		}).then((res) => {
			invoice.rfc = form.rfc.value;
			invoice.corporateName = form.corporateName.value.toUpperCase();
			invoice.email = form.email.value;
			invoice.zipCode = form.zipCode.value;
			invoice.amount = savedAmount;
			invoice.netPrice = savedNetPrice;
			setAmountMode("total");
			setAmountDraft(String(savedAmount));
			setRfcDraft(form.rfc.value);
			invoice.fiscalRegime = selectedFiscalRegime;
			invoice.street = form.street.value;
			invoice.city = form.city.value;
			invoice.use = selectedUse;
			invoice.state = form.state.value;
			invoice.paymentForm = selectedPaymentForm.replace(/_\d+$/, "");
			invoice.requestDate = firebaseDate;
			setModified(false);
			form.reset();
		});
	};

	const handleDiscardChanges = (e) => {
		e.preventDefault();
		e.target.form.reset();
		setModified(false);
		setRfcDraft(invoice.rfc ?? "");
		setAmountDraft(String(invoice.amount ?? ""));
		return;
	};

	const handleInvoiceChanges = async () => {
		if (!modified) {
			setModified(true);
		}
	};

	const getUserGenName = async () => {
		let tempGen = await getGenerationNameById(invoice.userGen);
		if (tempGen) {
			setUserGenName(
				tempGen.replace("Programa de Alto Rendimiento en 8 Idiomas Simultáneos -", "")
			);
		}
	};

	const dateHandler = () => {
		if (invoice.status === "Pending") {
			let formattedDate = firebaseDateFormatter(invoice.requestDate);
			setReqDate(formattedDate);
		} else if (invoice.status === "Rejected") {
			let formattedDate = firebaseDateFormatter(invoice.rejectedDate);
			setRejectedDate(formattedDate);
		} else if (invoice.status === "Canceled") {
			if (invoice.requestDate) {
				let formattedDate = firebaseDateFormatter(invoice.requestDate);
				setReqDate(formattedDate);
			}
			let formattedDate = invoice.canceledDate ? firebaseDateFormatter(invoice.canceledDate) : "-";
			setCanceledDate(formattedDate);
		} else {
			if (invoice.requestDate) {
				let formattedDate = firebaseDateFormatter(invoice.requestDate);
				setReqDate(formattedDate);
			}
			let formattedDate = firebaseDateFormatter(invoice.acceptedDate);
			setAcceptedDate(formattedDate);
		}
	};

	const handleInvoiceCancelation = async () => {
		if (window.confirm("Estas seguro de cancelar esta factura?")) {
			setLoader(true);
			let tempValidation = await props.cancelInvoice(invoice.ApiId, invoice.id);
			console.log(tempValidation);
			if (props.collaborator && tempValidation) {
				let tempCollaborator: collaborator = {
					name: props.collaborator.name,
					id: props.collaborator.id,
					role: props.collaborator.collaborator_rol ?? "",
				};
				let tempUser: user = { name: invoice.name, id: invoice.userId ?? "" };
				await invoiceLog("cancel", tempCollaborator, tempUser);
				await props.setContactNotificationSeen(invoice.id);
			}
			props.getInvoices();
			setLoader(false);
		} else {
			return;
		}
	};

	const handleDownload_file = async (format: string) => {
		let matricula = "";
		if (invoice.userId && !invoice.matricula) {
			const userRef = doc(db, "users", invoice.userId);
			const userDoc = await getDoc(userRef);

			if (userDoc.exists()) {
				matricula = userDoc.data().matricula;
			}
		} else {
			matricula = invoice.matricula;
		}
		props.downloadInvoice(invoice.ApiId, invoice.ticketNumber, matricula, format);
	};

	// "Aprobar" timbra con los impuestos de la tarjeta, después de confirmar el desglose.
	const handleAccept = async () => {
		const taxError = validateTaxConfig(taxCfg);
		if (taxError || !draftBreakdown) {
			alert(taxError ?? "Revisa el monto: no se pudo calcular el desglose.");
			return;
		}
		if (!window.confirm(`¿Timbrar la factura con este desglose?\n\n${breakdownText(draftBreakdown, taxCfg)}`)) return;
		setLoader(true);
		let tempValidation = await props.acceptInvoice(invoice, taxCfg, {
			mode: amountMode,
			amount: parseFloat(amountDraft),
		});
		if (props.collaborator && tempValidation) {
			let tempCollaborator: collaborator = {
				name: props.collaborator.name,
				id: props.collaborator.id,
				role: props.collaborator.collaborator_rol ?? "",
			};
			let tempUser: user = { name: invoice.name, id: invoice.userId ?? "" };
			await invoiceLog("accept", tempCollaborator, tempUser);
			await props.setContactNotificationSeen(invoice.id);
		}
		setLoader(false);
	};

	const handleReject = async () => {
		if (window.confirm("Estas seguro de rechazar esta solicitud?")) {
			console.log(invoice.id, invoice.name);
			await props.setContactNotificationSeen(invoice.id);
			props.setInvoiceToReject(invoice);
			props.setRejectInvoiceModal(true);
		} else {
			return;
		}
	};

	const getStatusSpanish = (status: string) => {
		return statusSpanish[status];
	};

	const getPaymentFormText = (pf: string) => {
		return paymentFormText[pf];
	};

	useEffect(() => {
		// Dates come as a firebase timestamp, so is important to format them accordingly
		setReqDate("");
		setRejectedDate("");
		setAcceptedDate("");
		if (invoice !== undefined) {
			dateHandler();
			if (invoice.userGen) {
				getUserGenName();
				if (!invoice.userGenName) {
					props.addGeneration(invoice);
				}
			}
		}
		// Solo se establece la vista en 1 si no está ya en otro estado
		if (view !== 2 && view !== 3) {
			setView(1);
		}
		if (invoice.createdAt) {
			let tempValidation = props.cancelationValidation(invoice.createdAt);
			setAbleToCancel(tempValidation);
		}
	}, [invoice, props.cat, invoice.requestDate]);

	useEffect(() => {
		if (location?.state !== undefined && location?.state?.invoiceId === cardRef.current.id) {
			props.setCategorie(location?.state.cat);
			cardRef.current.scrollIntoView({ behavior: "smooth", block: "end" });
			cardRef.current.style.border = "3px solid red";
			location.state = undefined;
		} else {
			cardRef.current.style.border = "none";
		}
	}, [location?.state]);

	return (
		<div id={invoice.id} ref={cardRef} className="invoice-admin-card-main-container">
			<form onSubmit={handleSaveChanges} onChange={trackDraft}>
				{(view === 1 || view === 3) && (
					<div className="iac1">
						<div className="iac1-who">
							<span className={"iac1-name " + statusColor}>{invoice.name}</span>
							<span className="iac1-sub">
								{[invoice.corporateName, invoice.rfc && `RFC ${invoice.rfc}`].filter(Boolean).join(" · ")}
							</span>
						</div>
						<div className="iac1-amount">{money(Number(invoice.amount) || 0)}</div>
						<div className="iac1-date">
							<span>
								{isPending
									? "Fecha de solicitud"
									: invoice.status === "Rejected"
									? "Fecha de rechazo"
									: invoice.status === "Canceled"
									? "Fecha de cancelación"
									: "Fecha de aceptación"}
							</span>
							<b className={isPending ? "" : statusColor}>
								{isPending
									? reqDate
									: invoice.status === "Rejected"
									? rejectedDate
									: invoice.status === "Canceled"
									? canceledDate
									: acceptedDate}
							</b>
						</div>
						<span className={"fac-pill " + statusColor}>{getStatusSpanish(invoice.status)}</span>
						<div className="iac1-actions">
							{view === 1 &&
								(invoice.status === "Rejected" || isPending ? (
									<button
										type="button"
										className="iac2-btn ghost"
										onClick={invoice.status === "Rejected" ? handleViewChange3 : handleViewChange2}
									>
										Revisar
									</button>
								) : (
									<button type="button" className="iac2-btn primary" onClick={handleViewChange2}>
										Ver factura
									</button>
								))}
							{view === 3 && (
								<button type="button" className="iac2-close" onClick={handleViewChange1} aria-label="Cerrar">
									×
								</button>
							)}
						</div>
					</div>
				)}
				{view === 3 && (
					<div className="iac1-reject">
						<span>Motivo del rechazo</span>
						<b>{invoice.rejectReason}</b>
					</div>
				)}
				{view === 2 && (
					<div className="iac2">
						<div className="iac2-header">
							<div className="iac2-title">
								<span
									className={
										"iac2-name " +
										(invoice.status === "Rejected" || invoice.status === "Canceled"
											? "red"
											: invoice.status !== "Pending"
											? "green"
											: "")
									}
								>
									{invoice.name}
								</span>
								<span
									className={
										"iac2-pill " +
										(invoice.status === "Rejected" || invoice.status === "Canceled"
											? "red"
											: invoice.status === "Pending"
											? "grey"
											: "green")
									}
								>
									{getStatusSpanish(invoice.status)}
								</span>
								{invoice.userGen && <span className="iac2-sub">Generación: {userGenName}</span>}
							</div>
							<div className="iac2-header-actions">
								<button className="iac2-btn ghost" onClick={() => setUserProfileModal(true)} type="button">
									Ver perfil
								</button>
								<button className="iac2-close" onClick={handleViewChange1} type="button" aria-label="Cerrar">
									×
								</button>
							</div>
						</div>

						<div className="iac2-body">
							<div className="iac2-data">
								<section className="iac2-section">
									<h4>Datos fiscales</h4>
									<div className="iac2-grid">
										<label className="iac2-field">
											<span>RFC</span>
											{isPending ? (
												<input defaultValue={invoice.rfc} maxLength={15} onChange={handleInvoiceChanges} name="rfc" required />
											) : (
												<b>{invoice.rfc}</b>
											)}
										</label>
										<label className="iac2-field">
											<span>Correo</span>
											{isPending ? (
												<input
													defaultValue={invoice.email}
													onChange={handleInvoiceChanges}
													name="email"
													required
													maxLength={50}
													type="email"
												/>
											) : (
												<b>{invoice.email}</b>
											)}
										</label>
										<label className="iac2-field wide">
											<span>Razón social</span>
											{isPending ? (
												<input
													defaultValue={invoice.corporateName}
													onChange={handleInvoiceChanges}
													name="corporateName"
													maxLength={70}
													required
												/>
											) : (
												<b>{invoice.corporateName}</b>
											)}
										</label>
										<label className="iac2-field wide">
											<span>Régimen fiscal</span>
											{isPending ? (
												<select
													name="fiscalRegime"
													value={selectedFiscalRegime}
													onChange={(e) => {
														setSelectedFiscalRegime(e.target.value);
														handleInvoiceChanges();
													}}
													required
												>
													<option value="" disabled>
														Selecciona una opción
													</option>
													{FISCAL_REGIMES.map(([code, text]) => (
														<option key={code} value={code}>
															({code}) {text}
														</option>
													))}
												</select>
											) : (
												<b>{invoice.fiscalRegime}</b>
											)}
										</label>
									</div>
								</section>

								<section className="iac2-section">
									<h4>Domicilio fiscal</h4>
									<div className="iac2-grid">
										<label className="iac2-field wide">
											<span>Calle <i className="iac2-opt">(opcional)</i></span>
											{isPending ? (
												<input defaultValue={invoice.street} onChange={handleInvoiceChanges} name="street" maxLength={70} />
											) : (
												<b>{invoice.street}</b>
											)}
										</label>
										<label className="iac2-field">
											<span>Ciudad <i className="iac2-opt">(opcional)</i></span>
											{isPending ? (
												<input defaultValue={invoice.city} onChange={handleInvoiceChanges} name="city" maxLength={45} />
											) : (
												<b>{invoice.city}</b>
											)}
										</label>
										<label className="iac2-field">
											<span>Estado <i className="iac2-opt">(opcional)</i></span>
											{isPending ? (
												<input defaultValue={invoice.state} onChange={handleInvoiceChanges} name="state" maxLength={70} />
											) : (
												<b>{invoice.state}</b>
											)}
										</label>
										<label className="iac2-field">
											<span>Código postal</span>
											{isPending ? (
												<input
													defaultValue={invoice.zipCode}
													onChange={handleInvoiceChanges}
													name="zipCode"
													required
													maxLength={11}
												/>
											) : (
												<b>{invoice.zipCode}</b>
											)}
										</label>
									</div>
								</section>

								<section className="iac2-section">
									<h4>Factura</h4>
									<div className="iac2-grid">
										<label className="iac2-field">
											<span>Uso de factura</span>
											{isPending ? (
												<select
													name="use"
													value={selectedUse}
													onChange={(e) => {
														setSelectedUse(e.target.value);
														handleInvoiceChanges();
													}}
													required
												>
													<option value="" disabled>
														Selecciona una opción
													</option>
													{USOS_CFDI.map(([code, text]) => (
														<option key={code} value={code}>
															{code} · {text}
														</option>
													))}
												</select>
											) : (
												<b>{invoice.use}</b>
											)}
										</label>
										<label className="iac2-field">
											<span>Método de pago</span>
											{isPending ? (
												<select
													name="fiscalRegime"
													value={selectedPaymentForm}
													onChange={(e) => {
														setSelectedPaymentForm(e.target.value);
														handleInvoiceChanges();
													}}
													required
												>
													<option value="" disabled>
														Selecciona una opción
													</option>
													<option value="01">Efectivo</option>
													<option value="03_1">Oxxo Pay</option>
													<option value="03_2">SPEI</option>
													<option value="03_3">Transferencia</option>
													<option value="03_4">Depósito Bancario</option>
													<option value="04_1">Tarjeta</option>
													<option value="04_2">Paypal</option>
													<option value="03_5">Otro</option>
												</select>
											) : (
												<b>{getPaymentFormText(invoice.paymentForm)}</b>
											)}
										</label>
										{invoice.requestDate && (
											<label className="iac2-field">
												<span>Fecha de solicitud</span>
												{isPending ? (
													<input
														type="date"
														defaultValue={defaultDateValue}
														onChange={handleInvoiceChanges}
														name="requestDate"
														required
													/>
												) : (
													<b>{reqDate}</b>
												)}
											</label>
										)}
										{acceptedDate && (
											<div className="iac2-field">
												<span>Fecha de aceptación</span>
												<b className="green">{acceptedDate}</b>
											</div>
										)}
										{invoice.status === "Canceled" && (
											<div className="iac2-field">
												<span>Fecha de cancelación</span>
												<b className="red">{canceledDate}</b>
											</div>
										)}
									</div>
								</section>
							</div>

							<aside className="iac2-money">
								{isPending ? (
									<MontoBar
										amountInputProps={{
											defaultValue: invoice.amount,
											name: "invoiceAmount",
											onChange: handleInvoiceChanges,
										}}
										amount={parseFloat(amountDraft)}
										mode={amountMode}
										setMode={setAmountMode}
										rfc={rfcDraft}
										value={taxCfg}
										onChange={setTaxCfg}
									/>
								) : (
									<table className="it-breakdown">
										<tbody>
											<tr>
												<td>Subtotal</td>
												<td>$ {invoice.netPrice} MXN</td>
											</tr>
											{invoice.ivaAmount !== undefined && (
												<tr>
													<td>IVA</td>
													<td>$ {invoice.ivaAmount} MXN</td>
												</tr>
											)}
											{!!invoice.retIvaAmount && (
												<tr>
													<td>Retención IVA</td>
													<td>−$ {invoice.retIvaAmount} MXN</td>
												</tr>
											)}
											{!!invoice.retIsrAmount && (
												<tr>
													<td>Retención ISR</td>
													<td>−$ {invoice.retIsrAmount} MXN</td>
												</tr>
											)}
											<tr className="it-total">
												<td>Total</td>
												<td>$ {invoice.amount} MXN</td>
											</tr>
										</tbody>
									</table>
								)}
							</aside>
						</div>

						<div className="iac2-footer">
							{!invoice.paymentReceiptLink && !invoice.acceptedDate && (
								<Alert variant={"danger"} className="iac2-alert">
									Esta solicitud no cuenta con un comprobante.
								</Alert>
							)}
							{isPending && !ableToCancel && (
								<Alert variant={"warning"} className="iac2-alert">
									El periodo para aprobar esta factura ya pasó.
								</Alert>
							)}
							<div className="iac2-footer-left">
								{isPending && (
									<button
										type="button"
										className="iac2-btn danger-ghost"
										title="Borrar solicitud"
										onClick={() => {
											Swal.fire({
												title: `¿Eliminar la solicitud de ${invoice?.name}?`,
												text: "La solicitud se eliminará permanentemente.",
												icon: "warning",
												showCancelButton: true,
												confirmButtonColor: "#3085d6",
												cancelButtonColor: "#d33",
												confirmButtonText: "Sí, eliminar",
												cancelButtonText: "No, cancelar",
												backdrop: false,
											}).then(async (result) => {
												if (result.isConfirmed) {
													try {
														await props.deleteInvoiceById(invoice.id);
														await props.getInvoices();
														if (props.collaborator) {
															let tempCollaborator: collaborator = {
																name: props.collaborator.name,
																id: props.collaborator.id,
																role: props.collaborator.collaborator_rol ?? "",
															};
															let tempUser: user = { name: invoice.name, id: "" };
															await invoiceLog("deleted", tempCollaborator, tempUser);
														}
														toast.success("Factura eliminada con éxito");
													} catch (error) {
														console.error("Hubo un error al borrar la factura:", error);
														toast.error("Hubo un error al borrar la factura");
													}
												}
											});
										}}
									>
										<img src={Bottletrash} alt="" /> Borrar
									</button>
								)}
								{invoice.paymentReceiptLink && !invoice.acceptedDate && (
									<a href={invoice.paymentReceiptLink} target="_blank" rel="noreferrer" className="iac2-btn ghost">
										Ver comprobante
									</a>
								)}
							</div>
							<div className="iac2-footer-right">
								{modified ? (
									<>
										<button onClick={handleDiscardChanges} className="iac2-btn ghost" type="button">
											Descartar cambios
										</button>
										<button type="submit" onClick={handleSaveChanges} className="iac2-btn primary">
											Guardar cambios
										</button>
									</>
								) : (
									isPending && (
										<>
											<button className="iac2-btn danger-ghost" onClick={handleReject} type="button">
												Rechazar
											</button>
											{ableToCancel && (
												<button
													className="iac2-btn primary"
													onClick={handleAccept}
													type="button"
													disabled={loader}
												>
													{!loader ? "Aprobar y timbrar" : <SpinnerCustom height={"auto"} />}
												</button>
											)}
										</>
									)
								)}
								{invoice.acceptedDate && (
									<button type="button" className="iac2-btn primary" onClick={() => setInvoiceActionsModal(true)}>
										Acciones de factura
									</button>
								)}
							</div>
						</div>
						{modified && (
							<div className="iac2-hint">Guarda o descarta los cambios para poder aprobar o rechazar.</div>
						)}
					</div>
				)}
			</form>
			<UserProfileModal
				show={userProfileModal}
				onHide={() => setUserProfileModal(false)}
				userId={invoice.userId}
			/>
			<InvoiceActionsModal
				show={invoiceActionsModal}
				onHide={() => setInvoiceActionsModal(false)}
				invoice={invoice}
				onCancelInvoice={props.cancelInvoice}
				onDownloadInvoice={props.downloadInvoice}
			/>
		</div>
	);
}
